// extracted by mini-css-extract-plugin
export var button = "_49-0";
export var icon = "_49-1";